import { Box, Card, Grid, Stack, Typography } from '@mui/material';
import { AdSpendCardProps } from '@features/campaigns/components/AdSpendCard';
import { HeroMetricProps } from '../../../../../components/Summary/HeroMetric';
import { Lci3Report } from '@components/Dashboard/dashboardSlice/schemas/lci3Reports';
import { AdSpendCard } from './AdSpendCard';

type SummaryCardProps = {
  campaignId: number;
  color: Extract<HeroMetricProps['colorScheme'], 'visit' | 'sales'>;
  label: string;
  metrics: AdSpendCardProps['metrics'];
  children?: React.ReactNode;
  allReports: Lci3Report[];
};

export const SummaryCard = (props: SummaryCardProps) => {
  return (
    <Card sx={{ padding: '1rem' }}>
      <Stack direction="column" spacing="1rem">
        <Typography variant="h5">{props.label}</Typography>

        <Box>
          <Grid container spacing="1rem">
            <Grid
              size={{
                md: 12,
                lg: 12,
              }}
            >
              <AdSpendCard color={props.color} metrics={props.metrics} />
            </Grid>
          </Grid>
        </Box>

        {props.children}
      </Stack>
    </Card>
  );
};
